// src/components/AppFooter.jsx
//
// Compact footer for the LOGGED-IN user area only (rendered by
// UserLayout.jsx). Fork of Footer.jsx — Footer.jsx keeps rendering
// unchanged for the public site. Internal app screens don't need the
// full marketing footer (office addresses, social links, service list);
// this keeps just the essentials (contact + quick links + copyright).
import React from "react";
import { Link } from "react-router-dom";
import { FaPhone } from "react-icons/fa6";
import { LuMail } from "react-icons/lu";
import "../css/appFooter.css";

const AppFooter = () => {
  return (
    <footer className="app-footer">
      <div className="container app-footer__inner">
        <div className="app-footer__links">
          <Link to="/chinh-sach">Chính sách</Link>
          <Link to="/lien-he">Liên hệ</Link>
          <Link to="/instruction">Hướng dẫn</Link>
        </div>
        <div className="app-footer__contact">
          <a href="tel:0364758606">
            <FaPhone size={13} className="me-1" /> 0364.758.606
          </a>
          <a href="mailto:ztovietnam.vn@gmail.com">
            <LuMail size={13} className="me-1" /> ztovietnam.vn@gmail.com
          </a>
        </div>
        <div className="app-footer__copyright">
          © {new Date().getFullYear()} ZTO Việt Nam — Logistics Trung - Việt
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
